import React from 'react';
import { components } from 'react-select';

class DynamicElementOption extends React.Component {
  render() {
    const { data } = this.props;
    return <components.Option {...this.props}>{data.name}</components.Option>;
  }
}

class DynamicElementValue extends React.Component {
  render() {
    const { data } = this.props;

    return <div className="Select-value">{data.name}</div>;
  }
}

const dynamicElementOptionFormatter = options => {
  return options.list.map(option => {
    return dynamicElementSingleOptionFormatter(option);
  });
};

const dynamicElementSingleOptionFormatter = option => {
  return { ...option, value: option.id, label: option.name };
};

const dynamicElementOptionFromEntity = element => {
  return !element
    ? null
    : dynamicElementSingleOptionFormatter({
        id: element.getId(),
        name: element.getName(),
      });
};

export {
  DynamicElementValue,
  DynamicElementOption,
  dynamicElementOptionFormatter,
  dynamicElementSingleOptionFormatter,
  dynamicElementOptionFromEntity,
};
